module.exports = __webpack_public_path__ + "ye.8244b2d2a803cff9823c.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/ye.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/ye.svg
// module chunks = styles